import { secureStorage } from "./secureStorage";

export const useAuth = () => {
  const user = secureStorage.getItem("user");
  const accessToken = secureStorage.getItem("accessToken");
  const isLoggedIn = !!user && !!accessToken;

  return { user, accessToken, isLoggedIn };
};

export const useAdminAuth = () => {
  const user = secureStorage.getItem("admin");
  const accessToken = secureStorage.getItem("adminToken");
  const isAdmin = !!user && !!accessToken;

  return { user, accessToken, isAdmin };
};
export const useClientAuth = () => {
  const company = secureStorage.getItem("client");
  const accessToken = secureStorage.getItem("clientToken");
  const isClient = !!company && !!accessToken;

  return { company, accessToken, isClient };
};
